export default __webpack_public_path__ + "static/hero_about_img_0-3da67235f3f9b300dd782f4f6333f523.png";